import React from 'react';
export function Disclaimer() {
  return <div className="w-full bg-dark text-gray-400 py-8 px-4 text-center" data-id="element-60">
      <div className="max-w-3xl mx-auto text-xs leading-relaxed space-y-3" data-id="element-61">
        <p className="font-bold uppercase tracking-widest text-gray-500 mb-3" data-id="element-62">
          Aviso Legal / Disclaimer
        </p>
        <p data-id="element-63">
          Los resultados pueden variar. Este protocolo es educativo y no
          reemplaza el consejo médico profesional. Consulta a tu médico antes de
          iniciar cualquier cambio en tu alimentación.
        </p>
        <p data-id="element-64">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <p className="pt-5 border-t border-gray-800" data-id="element-65">
          © {new Date().getFullYear()} Hígado Vital. Todos los derechos
          reservados.
        </p>
      </div>
    </div>;
}